module.exports = __webpack_public_path__ + "img/Pentester.61c091aa.svg";